import React from "react"
import { useTranslation } from "react-i18next"

import {
  Content,
  Title,
  Description,
  Wrapper,
} from "components/Subscription/Modal/Create/elements"
import Form from "components/Subscription/Modal/Create/MobilePaymentConfirmation/Form"
import { SUBSCRIPTION_MOBILE_CONFIRMATION_CODE } from "config"
import { SubscriptionPhoneConfirmationValues } from "types"

type Props = {
  subscription_id: string
  user_auth_request_id: string
  onSubmit: (values: SubscriptionPhoneConfirmationValues) => void
}

const SubscriptionMobilePaymentConfirmation = ({
  subscription_id,
  user_auth_request_id,
  onSubmit,
}: Props) => {
  const { t } = useTranslation()

  const handleSubmit = (values: SubscriptionPhoneConfirmationValues) => {
    onSubmit(values)
  }

  return (
    <Content>
      <Title variant="h4">
        {t("features.subscription.steps.confirmation.title")}
      </Title>
      <Description variant="h6">
        {t("features.subscription.steps.confirmation.description")}
      </Description>
      <Wrapper>
        <Form
          initialValues={{
            subscription_id: subscription_id,
            user_auth_request_id: user_auth_request_id,
            verification_code: SUBSCRIPTION_MOBILE_CONFIRMATION_CODE,
          }}
          onSubmit={handleSubmit}
        />
      </Wrapper>
    </Content>
  )
}

export default SubscriptionMobilePaymentConfirmation
